module.exports = __webpack_public_path__ + "img/asana.e44e546c.png";